define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var i18n = require('i18n');
    var Model = require('backbone').Model;
    var BaseView = require('common/base.view');
    var constants = require('common/addressLookup/sourceProvider/constants');
    var AddressProvider = require('common/addressLookup/sourceProvider/provider');

    require('widgets/autocomplete.widget');

    const DEFAULT_MIN_LENGTH = 1;

    module.exports = BaseView.extend({
        options: {
            template: 'addressLookupTmpl',
            label: '',
            infoTooltip: '',
            placeholder: '',
            active: true,
            innerFields: [],
            form: null,
            sourceProvider: null,
            visibleRows: 5,
            countryFieldName: null
        },

        events: {
            'keyup .fn-lookup-input-text': 'handleTextKeyup',
            'tap .fn-action-manual a': 'handleActionManualClick',
            'tap .fn-action-reset a': 'handleActionResetClick'
        },

        initialize: function(options) {
            this.options = { ...this.options, ...options };
            this.options.condition = Number(options?.condition) || DEFAULT_MIN_LENGTH;
            this.options.innerFields = Object.values(this.options.innerFields)
                .filter(field => field.active)
                .sort((field1, field2) => field1.order - field2.order)
                .map(field => {
                    field.isLabelAsteriskEnabled = field.validationRules?.some((rule) => rule.type === 'required' && rule.isLabelAsteriskEnabled);
                    field.isPlaceholderAsteriskEnabled = field.validationRules?.some((rule) => rule.type === 'required' && rule.isPlaceholderAsteriskEnabled);

                    return field;
                });

            this.setCountryFieldName();

            this.sourceProvider = new AddressProvider();
            this.model = new Model();
        },

        subscribe: function() {
            this.listenTo(this.model, 'change:loadingLocks', this.onChangeLoadingLocks);
        },

        handleTextKeyup: function(event) {
            if (event.key === 'Enter') {
                event.stopPropagation();
            }
        },

        handleActionManualClick: function(event) {
            event.preventDefault();

            this.enableManualInput();

            this.$el.find('.fn-action-manual').addClass('address-lookup-hidden');
            this.$el.find('.fn-action-reset').removeClass('address-lookup-hidden');
        },

        handleActionResetClick: function(event) {
            event.preventDefault();

            this.reset();

            this.$el.find('.fn-action-manual').removeClass('address-lookup-hidden');
            this.$el.find('.fn-action-reset').addClass('address-lookup-hidden');
        },

        onChangeLoadingLocks: function() {
            var locks = this.model.get('loadingLocks');

            this.$('.fn-lookup-input-text').toggleClass('progress__lookup', Boolean(locks.length));
        },

        onItemSelect: function(index) {
            var selectedItem = this.model.get('searchResult')[index];

            if (selectedItem.type === 'Address') {
                this.retrieve(selectedItem.id);

                return;
            }

            if (selectedItem.isRetrievedAddress) {
                this.setAddressResult([selectedItem]);

                return;
            }

            this.search(this.searchText, selectedItem.id);
        },

        onItemsShow: function() {
            this.options.form.resetField(this.$('.fn-lookup'));

            this.$('.fn-lookup-input-text').addClass('no-validate');
        },

        onItemsHide: function() {
            var $inputEl = this.$('.fn-lookup-input-text');

            $inputEl.removeClass('no-validate');

            if (document.activeElement === $inputEl.get(0)) {
                return;
            }

            this.options.form.validateField(this.$('.fn-lookup'), this.options.form.options.data);
        },

        search: function(value, id) {
            this.searchText = value;

            var countryCode = this.getCountryCode();
            var hideLoading = this.showLoading();

            this.sourceProvider.search(this.searchText, id, countryCode)
                .then(result => this.setSearchResult(result))
                .catch(error => this.handleError(error))
                .finally(() => hideLoading());
        },

        retrieve: function(id) {
            var hideLoading = this.showLoading();

            this.sourceProvider.retrieve(id)
                .then(result => this.setAddressResult(result))
                .catch(error => this.handleError(error))
                .finally(() => hideLoading());
        },

        setSearchResult: function(result = []) {
            if (!result.length) {
                this.hideDropDown();
                this.showError(i18n.t('playtech.mobile.registration.addressLookup.serviceError.noResults'));

                return;
            }

            this.showDropDown(result);
        },

        setAddressResult: function(result) {
            if (result.length > 1) {
                this.showDropDown(result, this.convertAddressToSearch(result));

                return;
            }

            this.toggleVisibility(true);

            this.$('.fn-lookup-input-text').val(result[0].label);
            this.$('.fn-lookup-inner').forEach(field => {
                var $visibleInput = $(field).find('input[type="text"]');
                var $hiddenInput = $(field).find('input[type="hidden"]');
                var val = result[0][field.dataset.name];

                if (val) {
                    $visibleInput.val(val);
                    $hiddenInput.val(val);

                    this.options.form.validateField(field);

                    $visibleInput.attr('disabled', 'disabled').addClass('inner-field-disabled');
                    $hiddenInput.removeAttr('disabled').removeClass('inner-field-disabled');
                }
            });

            this.hideDropDown();
        },

        handleError: function(error) {
            if (error.errorCode === constants.ABORT_ERROR) {
                return;
            }

            var defaultError = i18n.t('playtech.mobile.registration.addressLookup.serviceError.default');
            var message = i18n.tExt(
                'playtech.mobile.registration.addressLookup.serviceError.' + error.errorCode,
                error.errorMessage || defaultError
            );

            this.hideDropDown();
            this.showError(message);
        },

        showLoading: function() {
            var model = this.model;
            var lockId = window.Symbol('loadingLock');
            var loadingLocks = model.get('loadingLocks');

            model.set('loadingLocks', (loadingLocks || []).concat(lockId));

            return function hideLoading() {
                var locks = model.get('loadingLocks');

                model.set('loadingLocks', locks.filter(lock => lock !== lockId));
            };
        },

        showDropDown: function(cached, display) {
            this.model.set({ searchResult: cached });
            this.$('.fn-lookup-input-text').autocomplete('setResult', display || cached);
        },

        hideDropDown: function() {
            this.model.set({ searchResult: [] });
            this.$('.fn-lookup-input-text').autocomplete('setResult', []);
        },

        showError: function(message) {
            this.options.form.setFieldInvalid(this.$('.fn-lookup'), { message: message });
        },

        reset: function() {
            var form = this.options.form;

            this.$el.find('.fn-lookup, .fn-lookup-inner').forEach(el => {
                var $field = $(el);

                $field.find('input').forEach(input => {
                    input.value = '';
                    $(input).trigger('input');
                });

                form.resetField($field);
            });

            this.model.set({
                searchResult: null
            });

            this.toggleVisibility(false);
        },

        enableManualInput: function() {
            this.toggleVisibility(true);
        },

        convertAddressToSearch: function(addressResult) {
            return addressResult.map(item => ({
                id: item.id,
                text: item.address + ' ' + item.zip + ' ' + item.city
            }));
        },

        toggleVisibility: function(isVisible) {
            this.$('.fn-lookup').toggleClass('address-lookup-hidden', isVisible);
            this.$('.fn-lookup-input-text').toggleClass('no-validate', isVisible);

            this.$('.fn-lookup-inner').toggleClass('address-lookup-hidden', !isVisible);
            this.$('.fn-lookup-inner-input-text').toggleClass('inner-field-disabled', !isVisible);
            this.$('.fn-lookup-inner-input-hidden').toggleClass('inner-field-disabled', isVisible);

            if (isVisible) {
                this.$('.fn-lookup-inner-input-text').removeAttr('disabled').attr('autocomplete', 'on');
                this.$('.fn-lookup-inner-input-hidden').attr('disabled', 'disabled');
            } else {
                this.$('.fn-lookup-inner-input-text').attr('disabled', 'disabled').attr('autocomplete', 'off');
                this.$('.fn-lookup-inner-input-hidden').removeAttr('disabled');
            }
        },

        prepareRenderOptions: function() {
            var showInnerFields = this.options.innerFields && !this.sourceProvider.enabled;
            var innerFields = this.options.innerFields.map((cfg) => ({
                ...cfg,
                showInnerFields
            }));

            return {
                ...this.options,
                innerFields,
                showInnerFields
            };
        },

        render: function() {
            var renderOptions = this.prepareRenderOptions();

            if (!this.options.innerFields.length) {
                return this;
            }

            this.$el.html(this.tmpl(this.options.template, renderOptions));
            this.$el.removeClass('fn-validate');

            if (this.sourceProvider.enabled) {
                this.attachWidget(this.$el.find('.fn-lookup-input-text').autocomplete({
                    template: 'addressLookupItemTmpl',
                    className: 'address-lookup__autocomplete',
                    search: this.search.bind(this),
                    onSelect: this.onItemSelect.bind(this),
                    onItemsShow: this.onItemsShow.bind(this),
                    onItemsHide: this.onItemsHide.bind(this),
                    minLength: this.options.condition,
                    visibleRows: this.options.visibleRows,
                    collapseOnSelect: false,
                    collapseOnScroll: false
                }));
            }

            return this;
        },

        setCountryFieldName: function() {
            var fieldId = this.options.id;
            var rules = this.options.form.options.genericRules || [];

            rules.some(rule => {
                var hasRelatedAction = rule.actions.some(action => action.fieldId === fieldId);
                var conditionWithCountry = rule.conditions.find(condition => condition.field.startsWith('country'));

                if (!hasRelatedAction || !conditionWithCountry) {
                    return false;
                }

                this.options.countryFieldName = conditionWithCountry.field;

                return true;
            });
        },

        getCountryCode: function() {
            var fieldName = this.options.countryFieldName;

            if (!fieldName) {
                return null;
            }

            return this.options.form.$el.find(`[name="${fieldName}"]:not([disabled])`).val();
        }
    });
});
